/*
 * @Author: 317473294@qq.com
 * @Date: 2022-05-08 16:09:29
 * @LastEditTime: 2024-01-06 21:49:15
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/store/index.js
 */
import Vue from "vue";
import Vuex from "vuex";
import {tranArrToTreeData} from "@/router/dtRouter.js"
Vue.use(Vuex)

//全局管理数据存储
const state={
    isLogin:"0",
    ser:null,
    token:localStorage.getItem('token')?localStorage.getItem('token'):"",
    refreshToken:localStorage.getItem('refreshToken')?localStorage.getItem('refreshToken'):"",
    menus:localStorage.getItem('menus')?menusToJson():"",
    userinfo:localStorage.getItem('userinfo')?localStorage.getItem('userinfo'):"",
    permissions:null,
}

export default new Vuex.Store({
    state:state,
    // getters:{//监听数据变化

    // },
    mutations:{
        // 设置用户信息
        setUserInfo(state,userinfo){
            state.userinfo=userinfo;
            localStorage.setItem('userinfo',JSON.stringify(userinfo))
        },
        // 设置token
        setToken(state,token){
            state.token=token;
            localStorage.setItem('token',token)
        },
        // 设置刷新token
        setRefreshToken(state,refreshToken){
            state.refreshToken=refreshToken;
            localStorage.setItem('refreshToken',refreshToken)
        },
       //删除token
       removeToken(state,token){
           state.token="";
           localStorage.removeItem("token")
           localStorage.removeItem("refreshToken")
       },
       //设置权限菜单
       setRoleMenu(state,menus){
        state.menus=menus;
        // localStorage.setItem('menus',menus)
       },
       //删除权限菜单
       removeRoleMenu(state,menus){
        state.menus="";
        localStorage.removeItem('menus')
       },
       //设置用户权限
       setUserPrimission(state,btns){
        state.permissions=btns
        localStorage.setItem('primission',btns)
       },
       

    }
})
//,刷新以后，从本地拿到菜单转换树形结构
function menusToJson(){
    // console.log(ok)
    let stateMenu=localStorage.getItem('menus')
    let menuTree=tranArrToTreeData(JSON.parse(stateMenu))
    return menuTree
}



// WEBPACK FOOTER //
// ./src/store/index.js